// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreReservationsEnCours = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_RESERVATION_EN_COURS:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_RESERVATION_EN_COURS:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_RESERVATION_EN_COURS:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_RESERVATION_EN_COURS:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_RESERVATION_EN_COURS:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_RESERVATION_EN_COURS:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_RESERVATION_EN_COURS:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_RESERVATION_EN_COURS:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_RESERVATION_EN_COURS:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_RESERVATION_EN_COURS:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_RESERVATION_EN_COURS:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_RESERVATION_EN_COURS:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_RESERVATION_EN_COURS:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreReservationsEnCours;
